import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from '@angular/core';
import {NZ_MODAL_DATA, NzModalRef} from 'ng-zorro-antd/modal';

@Component({
    // Angular 22 defaults to OnPush; Eager preserves the previous behaviour.
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'di-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class DiConfirmDialogComponent implements OnInit {
    data: any;
    includeNotes = false;
    cancelFirst = false;
    /** Render "\n" in the message as line breaks (blank line = "\n\n"). */
    preserveLineBreaks = false;
    notes = '';

    dialogParams: any = {
        message: 'Please confirm you want to proceed...',
        title: 'Confirmation',
        confirmText: 'Confirm',
        cancelText: 'Cancel'
    };

    constructor(
        @Inject(NZ_MODAL_DATA) public modalData: any,
        public modal: NzModalRef
    ) {
        this.data = modalData.data;
        this.includeNotes = modalData.includeNotes;
        this.cancelFirst = !!modalData.cancelFirst;
        this.preserveLineBreaks = !!modalData.preserveLineBreaks;
    }

    ngOnInit(): void {
        this.dialogParams = {...this.dialogParams, ...this.data};
    }

    confirmAction(): void {
        this.modal.destroy({isConfirm: true, notes: this.notes});
    }

    cancelAction(): void {
        this.modal.destroy({isConfirm: false});
    }
}
